import { http } from "./config";

export default {
  buscarMeuAcesso: () => http.get("acessos/me"),
  listarAcessos: () => http.get("acessos"),
  listarCatalogoPermissoes: () => http.get("acessos/permissoes/catalogo"),
  criarPermissao: (codigo) => http.post("acessos/permissoes", { codigo }),
  atualizarPermissoes: (id, payload) => http.put(`acessos/${id}/permissoes`, payload),
  resetarDoisFatores: (id) => http.post(`acessos/${id}/resetar-2fa`),
};
